import { setStepT, SET_STEP } from "../reducers/StepStage";

export const SetStep = ( data: setStepT['data'] ) => {
  return ( {
    type: SET_STEP,
    data: data
  } )
}
